import React from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Container } from '@material-ui/core';

import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import IconButton from '@material-ui/core/IconButton';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import tileData from './tileData';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper
    },
    gridList: {
        flexWrap: 'nowrap',
        // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
        transform: 'translateZ(0)',
        backgroundColor: theme.palette.primary.light
    },
    title: {
        color: theme.palette.primary.light,
    },
    titleBar: {
        background:
            'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
    },
    wrapper: {
        width: 100 + theme.spacing(2),
    },
    paper: {
        zIndex: 1,
        position: 'relative',
        margin: theme.spacing(1),
        padding: theme.spacing(5)
    },
    svg: {
        width: 100,
        height: 100,
    },
    polygon: {
        fill: theme.palette.common.white,
        stroke: theme.palette.divider,
        strokeWidth: 1,
    },
    icon: {
        color: '#ffffff8a'
    },
}));

export default function Clients({ }) {
    const classes = useStyles();
    const [elevation, setElevation] = React.useState(0);

    React.useEffect(() => {
        window.scrollTo(0, 1);
    }, []);

    return (
        <section id="clients">
            <div className="features-bg1">
                <Container>
                    <div className="heading">
                        <Typography variant="h4" className="efecto-espejo">
                            Clientes
                        </Typography>
                    </div>
                    {/* <Paper elevation={elevation} className={classes.paper} onMouseOver={() => setElevation(4)} onMouseOut={() => setElevation(0)}>
                        <Typography variant="h2">Listado de todos Clientes!</Typography>
                    </Paper> */}



                    <div className={classes.root}>
                        <GridList className={classes.gridList} cols={4.4}>
                            {tileData.map((tile) => (
                                <GridListTile key={tile.img} style={{height: '100px'}}>
                                    <img src={tile.img} alt={tile.title} />
                                    <GridListTileBar
                                        title={tile.title}
                                        // classes={{
                                        //     root: classes.titleBar,
                                        //     title: classes.title,
                                        // }}
                                        actionIcon={
                                            <IconButton aria-label={`star ${tile.title}`}>
                                                <StarBorderIcon className={classes.icon} />
                                            </IconButton>
                                        }
                                    />
                                </GridListTile>
                            ))}
                        </GridList>
                    </div>
                </Container>
            </div>
        </section>
    );
}